import { IStationInfo } from "../../dto";

export const mergeStationsSecondaryIds = (
  sourceStations: IStationInfo[],
  targetStations: IStationInfo[],
): IStationInfo[] => {
  if (
    !targetStations.length ||
    sourceStations.length !== targetStations.length
  ) {
    return targetStations;
  }

  return targetStations.map((station, index) => {
    const sourceStation = sourceStations[index];

    if (
      sourceStation?.id === station.id &&
      sourceStation.secondaryId &&
      !station.secondaryId
    ) {
      return { ...station, secondaryId: sourceStation.secondaryId };
    }

    return station;
  });
};
